export default __webpack_public_path__ + "static/media/60.26a83f9f.svg";